<template>
  <div class="map">
    <img
      v-if="isImage"
      :src="mapUrl"
      class="map-img">

    <iframe
      v-if="isPdf"
      :src="mapUrl"
      class="map-pdf">
    </iframe>
  </div>
</template>

<script>
export default {
  computed: {
    map: function () {
      const quizset = this.$store.state.quizset.quizset
      return quizset.get('map')
    },

    // TODO 苦肉の策 → どうにかしたい
    mapUrl: function () {
      let url = this.map.url()
      if (url && process.env.NODE_ENV === 'production') {
        url = url.replace(/^http:/, 'https:')
      }
      return url
    },

    isPdf: function () {
      return this.map.name().includes('pdf')
    },

    isImage: function () {
      const types = ['png', 'jpeg']
      return  types.some((t) => {
        return this.map.name().includes(t)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.map {
  width: 100%;
  height: auto;
  overflow-y: auto;
}

.map-img {
  width: 100%;
  height: auto;
}

.map-pdf {
  width: 100vw;
  height: 100vh;
  frameborder: 0;
}
</style>
